import ComponentWithSocket from '../../lib/component';
import { Component } from 'vue-property-decorator';

import * as Store from './../../store';

import template from './register.vue';

import PhoneInput from '../../components/phone-input/index';
import {
    PhoneValidation,
    PhoneValue,
    PHONE_CONFIRMATION_SMS,
} from '../../utils/phone-validation';

interface UserCheck {
    auctionUserStatus: number;
}

@Component({
    mixins: [template],
    components: {
        PhoneInput,
    },
})
export default class RegisterUser extends ComponentWithSocket {
    private firstname: string = '';
    private lastname: string = '';
    private email: string = '';
    private phone: PhoneValue = PhoneValidation.defaultValue();
    private password: string = '';
    private repassword: string = '';
    private acceptTos: boolean = false;

    redirectAuctionId?: string;

    data: UserCheck = {
        auctionUserStatus: 0,
    };

    constructor() {
        super();

        // Assign session values to store for global dispatch
        this.wsListener.onPost(
            'auth.register',
            (success: boolean, data: any) => {
                if (!success) {
                    Store.commitLoaderVisibility(this.$store, false);
                    return alert(data);
                }

                // Save the user data to localstorage
                this.wsListener.setAuthState(true, data);

                // Wait few ms to write the things
                setTimeout(() => {
                    Store.commitLoggedInState(this.$store, true);
                    Store.commitLoggedInUser(this.$store, data);

                    this.wsListener.reconnect(() => {
                        if (data.isAdmin) {
                            window.location.href = 'admin-stage.vikart.ro';
                            return;
                        }

                        if (
                            !this.$root.$options ||
                            !this.$root.$options.router
                        ) {
                            alert('Please refresh the page!');
                            return;
                        }

                        this.afterRegisterRedirect();
                    });
                }, 100);
            },
        );
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        let url = new URL(window.location.href);
        this.redirectAuctionId = url.searchParams.get('auction')
            ? url.searchParams.get('auction')
            : this.$store.state.currentAuctionID;

        if (Store.readLoggedInState(this.$store)) {
            this.afterRegisterRedirect();
        }
    }

    afterRegisterRedirect() {
        if (!this.$root.$options || !this.$root.$options.router) return;

        const user = Store.readLoggedInUser(this.$store);

        // Pasul de confirmare a telefonului vine inaintea licitatiei si a verificarii
        if (user && user.phoneConfirmationPending) {
            this.$root.$options.router.push({
                name: 'account-verify-phone',
                query: this.redirectAuctionId
                    ? { auction: this.redirectAuctionId }
                    : {},
            });
        } else if (this.redirectAuctionId) {
            // If logged in and auction id is present, redirect to auction page
            this.$root.$options.router.push(
                '/auction/' + this.redirectAuctionId,
            );
        } else {
            // Redirect to my account when logged in and no auctionId
            this.$root.$options.router.push('/account');
        }
    }

    doRegister() {
        if (!this.acceptTos) {
            return alert(
                'Te rugam sa accepti Termenii și Condițiile, Politicile de Confidențialitate și Utilizare a cookie-urilor și tehnologiilor similare.',
            );
        }

        // Do some validation
        if (this.repassword !== this.password) {
            Store.commitLoaderVisibility(this.$store, false);
            return alert('Parolele nu se potrivesc!');
        }

        const phoneError = PhoneValidation.validate(this.phone);
        if (phoneError) {
            return alert(phoneError);
        }

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('auth.register', {
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            ...PhoneValidation.toPayload(this.phone),
            phoneConfirmation: PHONE_CONFIRMATION_SMS,
            password: this.password,
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/register/index.ts